export default {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  user: null,
  users: [],
  student: null,
  students: []
}
